// src/stores/MatabService.js

import { ref } from "vue";
import { defineStore } from "pinia";
import { useToast } from "vue-toastification";
import apiClient from '@/axios';
import { useConfirm } from '@/stores/composables.js'

const toast = useToast();

export const useMatabServiceStore = defineStore("MatabService", () => {
  const matabServiceList = ref([]);
  const loading = ref(false);
  const pagination = ref({ total: 0, current_page: 1, per_page: 20 });
  const searchQuery = ref("");

  async function fetchMatabService(page = 1) {
    loading.value = true;
    try {
      const requestBody = {
        filters: [], //  اضافه کردن فیلترهای دلخواه
        page,
        perPage: pagination.value.per_page,
        searchColumn: ["F_scode", "F_sname"],
        search: searchQuery.value,
        orderBy: "F_sauto DESC"
      };
      const response = await apiClient.post('/MatabService/GetAllAsync', requestBody);
      // جایگزینی آرایه با کپی جدید برای ردیابی تغییرات
      matabServiceList.value = [...response.data.result];

      // بروزرسانی pagination با مقادیر API یا پیش‌فرض
      pagination.value = {
        total: response.data.totalCount || 0,
        current_page: response.data.currentPage || page,
        per_page: response.data.perPage || 20
      };
    } catch (error) {
      console.error("Error fetching MatabService:", error);
    } finally {
      loading.value = false;
    }
  }

  async function addMatabService(MatabServiceData) {
    loading.value = true;
    try {
      const response = await apiClient.post('/MatabService', MatabServiceData);

      if (response.status === 200) {
        toast.success("کالا/خدمات با موفقیت ثبت شد");
        searchQuery.value = "";
        await fetchMatabService(1); // جدول را بلافاصله بروزرسانی کن
      } else {
        toast.error("خطا در ثبت اطلاعات کالا/خدمات");
        console.error(response.data);
      }
    } catch (error) {
      console.error("Error adding MatabService:", error);
      toast.error("خطا در ثبت اطلاعات کالا/خدمات");
    } finally {
      loading.value = false;
    }
  }

  async function updateMatabService(input) {
    loading.value = true;
    try {
      const response = await apiClient.put('/MatabService', input);
      if (response.status === 200) {
        toast.success("اطلاعات کالا/خدمات با موفقیت ویرایش شد");
        await fetchMatabService(pagination.value.current_page); // جدول را بروزرسانی کن
      } else {
        toast.error("خطا در ویرایش اطلاعات کالا/خدمات");
        console.error(response.data);
      }
    } catch (error) {
      console.error("Error updating MatabService:", error);
      toast.error("خطا در ویرایش اطلاعات کالا/خدمات");
    } finally {
      loading.value = false;
    }
  }

  async function deleteMatabService(id) {
    const { confirm } = useConfirm();
    const confirmed = await confirm("آیا از حذف این کالا/خدمات اطمینان دارید؟")
    if (!confirmed) return;
      loading.value = true;
      try {
        const response = await apiClient.delete(`/MatabService/${id}`);

        if (response.status === 200) {
          toast.success("کالا/خدمات با موفقیت حذف شد");
          await fetchMatabService(pagination.value.current_page);
        } else {
          toast.error("خطا در حذف کالا/خدمات");
          console.error(response.data);
        }
      } catch (error) {
        console.error("Error deleting MatabService:", error);
        toast.error("خطا در حذف کالا/خدمات");
      } finally {
        loading.value = false;
      }
    }

  return {
    matabServiceList,
    loading,
    pagination,
    searchQuery,
    fetchMatabService,
    addMatabService,
    updateMatabService,
    deleteMatabService
  };
});
